import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// react-router doesn't reset scroll position on navigation the way a
// classic multi-page site does, so clicking a link while scrolled down
// (e.g. a product card near the bottom) would land on the next page at
// the same scroll offset — header/logo stays off-screen. `behavior:
// "instant"` explicitly overrides the global `scroll-behavior: smooth`
// CSS so page changes don't animate-scroll on top of the route change.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
